// src/components/PrivateRoute.jsx
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const normalize = (s) => (typeof s === 'string' ? s.toLowerCase() : s);

export default function PrivateRoute({ children, requiredRole }) {
  const { user } = useContext(AuthContext);

  if (!user) return <Navigate to="/" />;

  const role = normalize(user.role);
  if (requiredRole && role !== normalize(requiredRole)) {
    // si no tiene permisos, mandalo a services o a donde prefieras
    return <Navigate to="/services" />;
  }

  return children;
}